import { Vue, Component, Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
    components: { ValidationProvider },
})
export default class FormSelect extends Vue {
    public localModel: any;

    @Prop({ type: Array, default: [] })
    public items: Array<Object>;

    @Prop({ type: String })
    public itemText: string;

    @Prop({ type: String })
    public itemValue: string;

    @Prop({ type: String })
    public rules: string;

    @Prop({ type: String })
    public name: string;

    @Prop({ type: String })
    public label: string;

    @Prop({ type: Boolean })
    public required: Boolean;

    @Prop({ type: Boolean })
    public star: Boolean;

    @Prop({ type: Boolean })
    public multiple: Boolean;

    @Prop({ type: Boolean })
    public creatable: Boolean;

    @Prop({ type: Boolean })
    public chips: Boolean;

    @Prop()
    value;

    @Prop()
    public change;

    mounted() {}
}
